/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderOrgChanges = function (this: any) {
  if (this.model.get('closed')) {
    return this.renderClosed();
  } else {
    return this.renderBoardHeader();
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const refreshOrganization = function (this: any) {
  const oldOrganization = this.modelCache.get(
    'Organization',
    this.model.previous('idOrganization'),
  );
  const organization = this.model.getOrganization();

  if (oldOrganization != null) {
    this.stopListening(oldOrganization);
  }

  if (organization != null) {
    for (const prop of [
      'name',
      'logoHash',
      'displayName',
      'limits',
      'products',
    ]) {
      this.listenTo(
        organization,
        `change:${prop}`,
        this.frameDebounce(this.renderOrgChanges),
      );
    }
  }

  return this.renderOrgChanges();
};
